import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {useLocation, Link } from 'react-router-dom';
import '../styles/SuperAdminLogin.css';
import { FaArrowLeft, FaLock, FaEnvelope } from 'react-icons/fa';

const SuperAdminLogin = ({ onLoginSuccess }) => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      setTimeout(() => setSuccessMessage(''), 5000);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email.trim()) {
      setError('Email is required');
      return;
    }

    if (!formData.password) {
      setError('Password is required');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
        email: formData.email,
        password: formData.password,
        role: 'super_admin'
      });

      if (response.data.success) {
        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('user', JSON.stringify(response.data.user));
        onLoginSuccess(response.data.user);
        
        // Navigate to super admin dashboard
        setTimeout(() => {
          window.location.href = '/super-admin/dashboard';
        }, 80);
      } else {
        setError(response.data.message || 'Login failed. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="super-admin-login-container">
      <div className="login-background">
        <div className="gradient-blob blob1"></div>
        <div className="gradient-blob blob2"></div>
      </div>

      <div className="login-card-super">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        <div className="login-header">
          <div className="admin-icon">👑</div>
          <h1>Super Admin Login</h1>
          <p>Access the control center</p>
        </div>

        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">
              <FaEnvelope /> Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your super admin email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <FaLock /> Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p>Demo Credentials:</p>
          
          <p className="disclaimer">
            ⚠️ For testing purposes only. Do not use in production with demo credentials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
